/* eslint-disable */
export default `<%
var displayClass = (data.displayed.toString() === 'false') ? ' displayNone' : '';
%>
<button
        id="<%= data.id %>"
        class="btn betbutton oddsbutton market__button <%= (data.status!=='A')?'disabled':'' %><%= displayClass %>"
        data-name="<%= data.name %>"
        data-displayed="<%= data.displayed %>"
        data-status="<%= data.status %>"
        data-player="<%= data.name %>"
        data-entityid="<%= data.id %>"
        data-market="<%= data.ancestors[0] %>"
        data-event="<%= data.ancestors[1] %>"
        data-odds="<%= data.currentPriceNum %>/<%= data.currentPriceDen %>"
        data-num="<%= data.currentPriceNum %>"
        data-denom="<%= data.currentPriceDen %>">

    <span class="selectiondetails" data-player="<%= data.name %>"
          data-odds="<%= data.currentPriceNum %>/<%= data.currentPriceDen %>" data-outcome="">
    </span>
    <span class="icon"></span>
</button>`;
